module.exports = __webpack_public_path__ + "img/5.bdf29d93.svg";